import { RtkqSpin } from '@app/base';
import { useLazySearchProvidersQuery, EmployeeOverview } from '@app/main/api';
import { EMPTY_OPTION_SOURCE, Option, OptionSource, createEntireLoadOptionSource } from '@webinex/antik';
import { Dayjs } from 'dayjs';
import { orderBy } from 'lodash';
import { useMemo } from 'react';
import { formatters } from '@app/ui';
import { EmployeeOverviewContent, Name } from '../components';

function map(value: EmployeeOverview, minimal: boolean): Option {
  return {
    label: minimal ? (
      <Name value={value} />
    ) : (
      <div>
        <div className="ant-selected-only">
          <Name value={value} />
        </div>
        <div className="ant-selected-none">
          <EmployeeOverviewContent employee={value} compact />
        </div>
      </div>
    ),
    value: value.id,
    _searchValue: `${value.firstName} ${value.lastName}`,
    employee: value,
  };
}

export function useProviderSearchOptionSource(args: {
  specialtyId?: string;
  date?: Dayjs;
  minimal?: boolean;
  active?: boolean | null;
  oneOfIds?: string[];
  skip?: boolean;
}): OptionSource {
  const [fetchList, { currentData }] = useLazySearchProvidersQuery();
  const { specialtyId, date, skip, oneOfIds, minimal = true, active = true } = args;

  return useMemo(() => {
    if (skip) {
      return EMPTY_OPTION_SOURCE;
    }

    return createEntireLoadOptionSource({
      fn: () =>
        fetchList(
          {
            [RtkqSpin]: false,
            specialtyId: specialtyId,
            from: date?.tz(undefined, true).startOf('day').toISOString(),
            to: date?.tz(undefined, true).startOf('day').add(24, 'hour').toISOString(),
            active,
          },
          true,
        )
          .unwrap()
          .then((values) => {
            values = oneOfIds != null ? values.filter((x) => oneOfIds.includes(x.id)) : values;
            return orderBy(values, (x) => [!x.active, formatters.name(x)]).map((x) => map(x, minimal));
          }),
      searchBy: '_searchValue',
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchList, currentData, specialtyId, date, active, oneOfIds]);
}
